import { useNavigate } from "react-router-dom";
import { useCRFService } from "modules/Library/CRF/api/useCRFQuery";
import { GetUserData, showToastMessage } from "common/service/CommonService";
import { queryClient } from "api/queryClient";
import { CRFItem, SurveySavePayload } from "../helpers/crf.types";
import SurveyBuilder from "../components/SurveyBuilder";

const CRFAdd: React.FC = () => {
  document.title = "Add CRF | ZENTIXS VISTA"
  // Navigation
  const navigate = useNavigate();
  // CRF Service(s)
  const { InsertMutation } = useCRFService({});

  //-------------------------------------------------------------------------------------------
  //--> Record Insert
  //-------------------------------------------------------------------------------------------

  const onSave = ({ json }: SurveySavePayload): void => {
    if (!json?.title?.trim()) {
      showToastMessage("error", "Please enter survey title!");
      return;
    }

    const payload: Omit<CRFItem, "id"> = {
      name: json.title,
      json,
      branid: 1,
    };

    InsertMutation.mutate(payload, {
      onSuccess: (response) => {
        showToastMessage("success", response?.message);
        queryClient.invalidateQueries({ queryKey: ["crf-selectAll"] });
        navigate("/crf/list");
      },
      onError: (error) => {
        showToastMessage("error", error?.message ?? error);
      },
    });
  };

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <SurveyBuilder onSave={onSave} />
    </div>
  );
};

export default CRFAdd;
